import { type AxiosResponse } from 'axios'

export const downloadFileFromAxiosResponse = (
  response: AxiosResponse,
  fallbackFilename: string = 'codex_download.json'
) => {
  if (!response.data) return

  const blob = new Blob([JSON.stringify(response.data, null, 2)], { type: 'application/json' })
  const url = window.URL.createObjectURL(blob)

  // Get filename from content-disposition header
  const contentDisposition = response.headers?.['content-disposition']
  const filenameMatch = contentDisposition?.match(/filename=(.+)/)
  const filename = filenameMatch ? filenameMatch[1] : fallbackFilename

  // Create and trigger download
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()

  // Cleanup
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}
